import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_EMAIL_VERIFY_SUCCESS,
  FORGET_PASSWORD_OTP_VERIFY_SUCCESS,
  FORGET_PASSWORD_PASSWORD_CHANGE_SUCCESS, FORGET_PASSWORD_INITIAL,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  emailVerified: false,
  otpVerified: false,
  passwordChanged: false,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD_INITIAL:
      state ={
        emailVerified: false,
        otpVerified: false,
        passwordChanged: false,
      }
      break
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload }
      break
    case FORGET_PASSWORD_EMAIL_VERIFY_SUCCESS:
      state = {
        ...state,
        emailVerified: action.payload,
      }
      break
    case FORGET_PASSWORD_OTP_VERIFY_SUCCESS:
      state = {
        ...state,
        otpVerified: action.payload,
      }
      break
    case FORGET_PASSWORD_PASSWORD_CHANGE_SUCCESS:
      state = {
        ...state,
        passwordChanged: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
